/* B commerce: reuses the verified F01 cart core from post-patch MAIN.
   Own B forms only; no Impulse hooks, tracking emitters, registry or polling. */
(function (root, factory) {
  'use strict';
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else if (!root.RevalBCommerce) { root.RevalBCommerce = api; api.mount(root); }
})(typeof window !== 'undefined' ? window : this, function () {
  'use strict';
  var VARIANT = '51418024739111';
  var PENDING_KEY = 'reval-b04-delivery-notice-v1';
  var DELIVERY_KEYS = ['Entrega', 'Entrega estimada', '_Reval entrega', '_Reval entrega detalle'];

  function isTarget(item) { return String(item.variant_id || item.id) === VARIANT; }
  function clone(value) { return JSON.parse(JSON.stringify(value)); }
  function stable(value) {
    if (Array.isArray(value)) return '[' + value.map(stable).join(',') + ']';
    if (value && typeof value === 'object') return '{' + Object.keys(value).sort().map(function (key) {
      return JSON.stringify(key) + ':' + stable(value[key]);
    }).join(',') + '}';
    return JSON.stringify(value);
  }
  function problem(code, message) { var error = new Error(message); error.code = code; return error; }
  function variantId(item) { return String(item.variant_id || item.id); }
  function assertCart(cart) {
    if (!cart || !Array.isArray(cart.items) || cart.items.some(function (item) {
      return !item.key || !Number.isInteger(item.quantity) || item.quantity < 1;
    }) || new Set(cart.items.map(function (x) { return x.key; })).size !== cart.items.length) {
      throw problem('invalid_cart', 'No pudimos leer la bolsa completa. Vuelve a intentarlo.');
    }
  }
  function normalizedProperties(value) {
    if (!Array.isArray(value)) return value || {};
    var result = {};
    value.forEach(function (pair) {
      if (!Array.isArray(pair) || pair.length !== 2 || typeof pair[0] !== 'string' || Object.prototype.hasOwnProperty.call(result, pair[0])) throw problem('delivery_snapshot', 'No pudimos verificar las propiedades de tu bolsa.');
      Object.defineProperty(result, pair[0], { value: pair[1], enumerable: true, writable: true, configurable: true });
    });
    return result;
  }
  function correctedProperties(item, text) {
    var props = clone(item.properties || {});
    DELIVERY_KEYS.forEach(function (key) {
      if (key === 'Entrega' || Object.prototype.hasOwnProperty.call(props, key)) props[key] = text;
    });
    return props;
  }
  function itemSignature(item) {
    var record = {};
    ['variant_id', 'id', 'quantity', 'properties', 'selling_plan_allocation', 'parent_relationship',
      'price', 'original_price', 'final_price', 'line_price', 'original_line_price', 'final_line_price',
      'total_discount', 'discounts', 'line_level_discount_allocations', 'line_level_total_discount'].forEach(function (key) {
      if (key in item) record[key] = item[key];
    });
    record.properties = record.properties || {};
    return stable(record);
  }
  function cartContext(cart, codeNamesOnly) {
    // Shopify may materialize empty-cart metadata during the first Add. Only
    // absent/null/empty equivalents normalize; real notes, attributes and codes remain.
    var codes = cart.discount_codes == null ? [] : cart.discount_codes;
    var record = { note: cart.note == null ? '' : cart.note, attributes: cart.attributes == null ? {} : cart.attributes };
    if ('currency' in cart) record.currency = cart.currency;
    if (codeNamesOnly) record.codes = codes.map(function (x) { return typeof x === 'string' ? x : x.code; }).sort();
    else record.discount_codes = codes;
    return record;
  }
  function cartSignature(cart) {
    var record = cartContext(cart, false); record.items = cart.items.map(itemSignature).sort();
    ['item_count', 'total_price', 'original_total_price',
      'items_subtotal_price', 'total_discount', 'cart_level_discount_applications'].forEach(function (key) {
      if (key in cart) record[key] = cart[key];
    });
    return stable(record);
  }
  // Quantity changes may legitimately reprice discounts. Preserve line identity,
  // properties, base price, requested quantities, notes and entered codes instead.
  function quantityItem(item) {
    return { id: variantId(item), quantity: item.quantity, properties: item.properties || {},
      price: item.price, original_price: item.original_price,
      plan: item.selling_plan_allocation && item.selling_plan_allocation.selling_plan && item.selling_plan_allocation.selling_plan.id,
      parent: item.parent_relationship || null };
  }
  function quantitySignature(cart) {
    var record = cartContext(cart, true); record.items = cart.items.map(function (x) { return stable(quantityItem(x)); }).sort();
    return stable(record);
  }
  function validateRecord(record) {
    if (!record || record.version !== 1 || !/^\d+$/.test(record.variantId) ||
      typeof record.nativeAvailable !== 'boolean' || typeof record.supplier !== 'boolean' ||
      !Number.isInteger(record.localQty) || record.localQty < 0 ||
      !(record.maxQty === null || (Number.isInteger(record.maxQty) && record.maxQty >= 0)) ||
      !record.texts || ['local', 'supplier', 'unavailable'].some(function (s) { return typeof record.texts[s] !== 'string' || !record.texts[s]; })) {
      throw problem('delivery_unverified', 'No pudimos verificar la entrega de esta variante. Vuelve a intentarlo.');
    }
    return record;
  }
  function resolveDelivery(record, quantity) {
    validateRecord(record);
    var route = 'unavailable';
    if (Number.isInteger(quantity) && quantity > 0 && record.nativeAvailable && (record.maxQty === null || quantity <= record.maxQty)) {
      if (quantity <= record.localQty) route = 'local';
      else if (record.supplier) route = 'supplier';
    }
    return { state: route, text: record.texts[route], quantity: quantity, eligible: route !== 'unavailable' };
  }
  function recordsFromSnapshot(cart, snapshot) {
    assertCart(cart);
    if (!snapshot || snapshot.version !== 1 || !Array.isArray(snapshot.items) || snapshot.items.length !== cart.items.length) {
      throw problem('delivery_snapshot', 'La bolsa cambió al consultar su entrega. Recárgala antes de continuar.');
    }
    var byKey = new Map(snapshot.items.map(function (x) { return [x.key, x]; }));
    if (byKey.size !== cart.items.length) throw problem('delivery_snapshot', 'No pudimos verificar todas las líneas de la bolsa.');
    var records = Object.create(null);
    cart.items.forEach(function (item) {
      var row = byKey.get(item.key), id = variantId(item);
      if (!row || row.variantId !== id || row.quantity !== item.quantity || stable(normalizedProperties(row.properties)) !== stable(item.properties || {})) {
        throw problem('cart_drift', 'La bolsa cambió al consultar su entrega. Vuelve a intentarlo.');
      }
      var record = validateRecord(row.delivery);
      if (record.variantId !== id || (records[id] && stable(records[id]) !== stable(record))) throw problem('delivery_drift', 'La entrega cambió durante la consulta. Vuelve a intentarlo.');
      records[id] = record;
    });
    return records;
  }
  function addProperties(data) {
    var properties = {};
    for (var entry of data.entries()) {
      var match = /^properties\[(.+)\]$/.exec(entry[0]);
      if (!match) continue;
      if (typeof entry[1] !== 'string' || Object.prototype.hasOwnProperty.call(properties, match[1])) throw problem('add_conditions', 'No pudimos verificar las opciones del producto. Revisa tu selección.');
      Object.defineProperty(properties, match[1], { value: entry[1], enumerable: true, writable: true, configurable: true });
    }
    return properties;
  }
  // Native add may merge identical lines or split discount allocations. Compare
  // quantities by exact properties/mode/base price, not volatile line keys.
  function addBalance(cart) {
    var groups = Object.create(null);
    cart.items.forEach(function (item) {
      var signature = stable({ id: variantId(item), properties: item.properties || {}, price: item.price,
        originalPrice: item.original_price === undefined ? item.price : item.original_price,
        plan: item.selling_plan_allocation && item.selling_plan_allocation.selling_plan ? String(item.selling_plan_allocation.selling_plan.id) : '',
        parent: item.parent_relationship || null });
      groups[signature] = (groups[signature] || 0) + item.quantity;
    });
    var record = cartContext(cart, true); record.groups = groups;
    return stable(record);
  }
  function planCart(cart, records, incoming) {
    var totals = Object.create(null);
    cart.items.forEach(function (item) { var id = variantId(item); totals[id] = (totals[id] || 0) + item.quantity; });
    if (incoming) totals[incoming.id] = (totals[incoming.id] || 0) + incoming.quantity;
    return cart.items.map(function (item) {
      var delivery = resolveDelivery(records[variantId(item)], totals[variantId(item)]);
      return { key: item.key, variantId: variantId(item), delivery: delivery,
        properties: correctedProperties(item, delivery.text) };
    });
  }
  function preflight(cart, plan) {
    assertCart(cart);
    var signatures = new Map();
    cart.items.forEach(function (item, index) {
      var entry = plan[index];
      if (!entry.delivery.eligible) throw problem('route_unavailable', 'Agotado para la cantidad elegida: ' + (item.product_title || item.title || item.variant_title || variantId(item)) + '. Ajusta o retira esta línea antes de continuar.');
      var signature = stable([variantId(item), entry.properties, item.selling_plan_allocation || null, item.parent_relationship || null]);
      var stale = stable(item.properties || {}) !== stable(entry.properties);
      if (signatures.has(signature) && (stale || signatures.get(signature))) throw problem('merge_risk', 'Dos líneas de la misma variante podrían unirse al corregir la entrega. No modificamos esas líneas. Revisa tu bolsa.');
      signatures.set(signature, stale);
    });
  }
  function createController(io) {
    var tail = Promise.resolve(), flight = null, aliases = Object.create(null);
    function enqueue(work) { var task = tail.then(function () { return work(); }); tail = task.catch(function () {}); return task; }
    function resolveKey(key) { var count = 0; while (aliases[key] && count++ < 100) key = aliases[key]; return key; }
    async function currentRecords(cart, incoming) {
      if (!cart.items.length && !incoming) return Object.create(null);
      var snapshot = await io.getDelivery(cart, incoming && incoming.productURL);
      var records = recordsFromSnapshot(cart, snapshot);
      if (incoming) {
        var selected = validateRecord(snapshot.selected);
        if (selected.variantId !== incoming.id || !Number.isInteger(selected.price) || selected.price < 0 ||
          (records[incoming.id] && stable(records[incoming.id]) !== stable(selected))) {
          throw problem('add_conditions', 'No pudimos verificar las condiciones actuales de esta variante. Revisa tu bolsa antes de agregarla.');
        }
        records[incoming.id] = selected;
      }
      return records;
    }
    async function run(incoming) {
      var cart = await io.getCart(); assertCart(cart);
      var changed = 0, maximum = cart.items.length;
      for (var n = 0; n <= maximum; n++) {
        var records = await currentRecords(cart, incoming), plan = planCart(cart, records, incoming);
        if (incoming) {
          prepareAddData(incoming.data, records[incoming.id], cart);
          preflight({ items: cart.items.filter(function (item) { return variantId(item) === incoming.id; }) },
            plan.filter(function (entry) { return entry.variantId === incoming.id; }));
        } else preflight(cart, plan);
        var index = cart.items.findIndex(function (item, i) {
          return (!incoming || variantId(item) === incoming.id) && stable(item.properties || {}) !== stable(plan[i].properties);
        });
        if (index < 0) return { cart: cart, changed: changed, delivery: plan, records: records };
        if (n === maximum) throw problem('unstable_cart', 'La entrega volvió a cambiar. Revisa tu bolsa antes de continuar.');
        var stale = cart.items[index], fresh = await io.getCart(); assertCart(fresh);
        if (cartSignature(fresh) !== cartSignature(cart) || !fresh.items.some(function (item) { return item.key === stale.key; })) throw problem('cart_drift', 'Tu bolsa cambió durante la revisión. Vuelve a intentarlo.');
        var freshRecords = await currentRecords(fresh, incoming);
        if (stable(freshRecords) !== stable(records)) throw problem('delivery_drift', 'La entrega cambió durante la revisión. Vuelve a intentarlo.');
        var expected = clone(fresh); index = fresh.items.findIndex(function (item) { return item.key === stale.key; });
        expected.items[index].properties = planCart(fresh, freshRecords, incoming)[index].properties;
        if (io.onChangeStarted) io.onChangeStarted();
        assertCart(await io.changeItem({ id: stale.key, quantity: stale.quantity, properties: expected.items[index].properties }));
        var verified = await io.getCart(); assertCart(verified);
        if (cartSignature(verified) !== cartSignature(expected)) throw problem('verification_failed', 'No pudimos confirmar que la bolsa conserve todas sus líneas y condiciones. Recárgala; no repetimos el cambio automáticamente.');
        var replacement = verified.items.find(function (item) { return itemSignature(item) === itemSignature(expected.items[index]); });
        if (replacement && replacement.key !== stale.key) aliases[stale.key] = replacement.key;
        changed++; cart = verified;
        if (io.onCorrected) io.onCorrected(cart);
      }
    }
    async function update(rows) {
      var cart = await io.getCart(); assertCart(cart);
      var desired = reconcileRows(cart, rows, resolveKey), changed = 0;
      for (var entry of desired) {
        if (entry.value === entry.serverQuantity) continue;
        var fresh = await io.getCart(); assertCart(fresh);
        if (cartSignature(fresh) !== cartSignature(cart)) throw problem('cart_drift', 'Tu bolsa cambió. Recárgala antes de actualizar la cantidad.');
        var key = resolveKey(entry.key), index = fresh.items.findIndex(function (item) { return item.key === key; });
        if (index < 0) throw problem('line_changed', 'Esta línea cambió. Recarga tu bolsa.');
        var expected = clone(fresh), target = expected.items[index];
        target.quantity = entry.value;
        if (!entry.value) expected.items.splice(index, 1);
        assertCart(await io.changeItem({ id: key, quantity: entry.value }));
        var verified = await io.getCart(); assertCart(verified);
        if (quantitySignature(verified) !== quantitySignature(expected)) throw problem('quantity_verification', 'No pudimos confirmar la cantidad solicitada y las demás condiciones. Recarga tu bolsa; no repetimos el cambio automáticamente.');
        expected.items.forEach(function (expectedItem) {
          var replacements = verified.items.filter(function (item) { return stable(quantityItem(item)) === stable(quantityItem(expectedItem)); });
          var replacement = replacements.find(function (x) { return x.key === expectedItem.key; }) || (replacements.length === 1 ? replacements[0] : null);
          if (!replacement) throw problem('quantity_verification', 'Las líneas de tu bolsa cambiaron. Recárgala antes de continuar.');
          if (replacement.key !== expectedItem.key) aliases[expectedItem.key] = replacement.key;
        });
        changed++; cart = verified;
      }
      return { cart: cart, changed: changed };
    }
    async function add(data, productURL) {
      var id = String(data.get('id')), quantity = Number(data.get('quantity') || 1);
      if (!/^\d+$/.test(id) || !Number.isInteger(quantity) || quantity < 1 || quantity > 99) throw problem('quantity_invalid', 'Revisa la variante y la cantidad elegidas.');
      // B04 owns one-time, non-nested forms. Never strip a foreign purchase mode.
      if (data.get('selling_plan') || data.get('parent_id') || data.get('parent_line_key')) throw problem('add_conditions', 'No pudimos verificar esta modalidad del producto. Revisa tu selección.');
      addProperties(data);
      var incoming = { id: id, quantity: quantity, productURL: productURL, data: data };
      // Prepare existing target lines for the post-add TOTAL before native add.js.
      // Ordinary add1+add1 now has identical canonical properties and can be
      // merged by Shopify. Distinct custom properties are never consolidated.
      var prepared = await run(incoming);
      var fresh = await io.getCart(); assertCart(fresh);
      if (cartSignature(fresh) !== cartSignature(prepared.cart)) throw problem('cart_drift', 'Tu bolsa cambió. Revisa la cantidad antes de agregar esta variante.');
      var records = await currentRecords(fresh, incoming);
      if (stable(records) !== stable(prepared.records)) throw problem('delivery_drift', 'Las condiciones de la variante cambiaron. Vuelve a intentarlo.');
      prepareAddData(data, records[id], fresh);
      var expected = clone(fresh), properties = addProperties(data);
      expected.items.push({ id: Number(id), variant_id: Number(id), quantity: quantity, properties: properties,
        price: records[id].price, original_price: records[id].price });
      // A failed/ambiguous add is never repeated automatically.
      await io.addItem(data);
      var verified = await io.getCart(); assertCart(verified);
      if (addBalance(verified) !== addBalance(expected)) throw problem('add_verification', 'No pudimos confirmar la cantidad agregada y las demás condiciones. Revisa tu bolsa; no repetimos la acción automáticamente.');
      return { cart: verified, changed: prepared.changed };
    }
    return {
      sanitize: function () {
        if (flight) return flight;
        flight = enqueue(run); var current = flight;
        current.then(function () { if (flight === current) flight = null; }, function () { if (flight === current) flight = null; });
        return current;
      },
      updateQuantities: function (rows) { return enqueue(function () { return update(rows); }); },
      add: function (data, productURL) { return enqueue(function () { return add(data, productURL); }); },
      coordinate: enqueue, resolveKey: resolveKey
    };
  }
  function createGate(controller, state, confirm, present) {
    var flight = null;
    return function (resume) {
      if (flight) return flight;
      flight = (async function () {
        for (var attempt = 0; attempt < 3; attempt++) {
          var result = await controller.sanitize();
          if (result.changed) state.setPending(true);
          if (!result.cart.items.length) state.setPending(false);
          present(result.cart, result.delivery);
          if (state.getPending()) {
            if (!await confirm()) return false;
            state.setPending(false); continue;
          }
          await resume(); return true;
        }
        throw problem('repeated_change', 'La entrega volvió a cambiar. Revisa tu bolsa antes de continuar.');
      })();
      var current = flight;
      current.then(function () { if (flight === current) flight = null; }, function () { if (flight === current) flight = null; });
      return current;
    };
  }
  function prepareAddData(data, record, cart) {
    var id = String(data.get('id')), quantity = Number(data.get('quantity') || 1);
    if (!Number.isInteger(quantity) || quantity < 1 || quantity > 99) throw problem('quantity_invalid', 'Revisa la cantidad elegida.');
    if (!record || record.variantId !== id) throw problem('delivery_unverified', 'No pudimos verificar la entrega de esta variante.');
    var total = quantity + (cart ? cart.items : []).reduce(function (sum, item) { return sum + (variantId(item) === id ? item.quantity : 0); }, 0);
    var delivery = resolveDelivery(record, total);
    if (!delivery.eligible) throw problem('route_unavailable', 'Agotado para la cantidad elegida. Revisa tu selección.');
    DELIVERY_KEYS.forEach(function (key) {
      var field = 'properties[' + key + ']';
      if (key === 'Entrega' || data.has(field)) data.set(field, delivery.text);
    });
    return data;
  }
  function variantURL(productURL, id, currentURL) {
    var current = new URL(currentURL);
    var url = new URL(productURL, current.origin);
    // Public variant navigation carries only the selected variant and campaign fields.
    // Preview/private query parameters and fragments are not forwarded.
    url.search = '';
    url.hash = '';
    url.searchParams.set('variant', id);
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'utm_id', 'fbclid'].forEach(function (key) {
      var value = current.searchParams.get(key);
      if (value) url.searchParams.set(key, value);
    });
    return url.toString();
  }
  function reconcileRows(cart, rows, resolveKey) {
    if (rows.length !== cart.items.length) throw problem('view_changed', 'Tu bolsa cambió. Recárgala para revisar tu selección antes de continuar.');
    var byKey = new Map(rows.map(function (row) { return [resolveKey(row.key), row]; }));
    if (byKey.size !== rows.length) throw problem('view_changed', 'Tu bolsa cambió. Recárgala antes de continuar.');
    return cart.items.map(function (item) {
      var row = byKey.get(item.key);
      if (!row || String(row.variantId) !== String(item.variant_id || item.id)) throw problem('view_changed', 'Tu bolsa cambió. Recárgala antes de continuar.');
      if (String(row.value).trim() === '') throw problem('quantity_invalid', 'Revisa la cantidad elegida antes de continuar.');
      var quantity = Number(row.value);
      if (!Number.isInteger(quantity) || quantity < 0 || quantity > 99) throw problem('quantity_invalid', 'Revisa la cantidad elegida antes de continuar.');
      var edited = quantity !== Number(row.serverQuantity);
      if (edited && Number(row.serverQuantity) !== item.quantity) throw problem('quantity_changed', 'La cantidad de esta variante cambió. Recarga tu bolsa para revisarla.');
      return { row: row, key: item.key, serverQuantity: item.quantity, value: edited ? quantity : item.quantity };
    });
  }

  function mount(win) {
    var doc = win.document;
    var nativeCart = doc.getElementById('native-cart');
    var select = doc.getElementById('variant-select');
    var pageAddForm = doc.querySelector('[data-native-add][data-delivery-url]');
    var renderedVariantId = null, restoreVariantTimer = null;
    if (pageAddForm) {
      try { renderedVariantId = new win.URL(pageAddForm.dataset.deliveryUrl, win.location.origin).searchParams.get('variant'); } catch (_) {}
    }
    function restoreRenderedVariant() {
      // This SSR attribute identifies the gallery/price already rendered. Form
      // restoration may change .value, so neither the selector nor URL is its source.
      if (!pageAddForm || !renderedVariantId) return;
      var input = pageAddForm.querySelector('input[name="id"]');
      if (input) input.value = renderedVariantId;
      if (select) select.value = renderedVariantId;
    }
    restoreRenderedVariant();
    doc.addEventListener('reval:variant:commit', function (event) {
      var id = event.detail && String(event.detail.variantId || '');
      if (!pageAddForm || !id) return;
      var input = pageAddForm.querySelector('input[name="id"]');
      var rendered = new win.URL(pageAddForm.dataset.deliveryUrl, win.location.origin).searchParams.get('variant');
      if (input && input.value === id && rendered === id) renderedVariantId = id;
    });
    var pending = false;
    var bypass = null;
    var bypassLink = null;
    var actionFlight = null;
    var lastCart = null, lastDelivery = [];
    try { pending = win.sessionStorage.getItem(PENDING_KEY) === '1'; } catch (_) {}
    var state = {
      getPending: function () { return pending; },
      setPending: function (next) {
        pending = next;
        try { if (next) win.sessionStorage.setItem(PENDING_KEY, '1'); else win.sessionStorage.removeItem(PENDING_KEY); } catch (_) {}
      }
    };
    function endpoint(path) { return (win.Shopify && win.Shopify.routes ? win.Shopify.routes.root : '/') + path; }
    function viewURL(path) {
      var url = new win.URL(endpoint(path), win.location.origin);
      var preview = new win.URL(win.location.href).searchParams.get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      return url.toString();
    }
    async function request(path, data) {
      var abort = new win.AbortController();
      var timer = win.setTimeout(function () { abort.abort(); }, 12000);
      var options = { credentials: 'same-origin', cache: 'no-store', signal: abort.signal, headers: { Accept: 'application/json' } };
      if (data) {
        options.method = 'POST';
        if (data instanceof win.FormData) options.body = data;
        else { options.headers['Content-Type'] = 'application/json'; options.body = JSON.stringify(data); }
      }
      try {
        var response = await win.fetch(endpoint(path), options);
        var json = await response.json();
        if (!response.ok) throw problem('cart_request', json.description || 'No pudimos actualizar tu bolsa. Vuelve a intentarlo.');
        return json;
      } catch (error) {
        if (error.code) throw error;
        throw problem('cart_network', 'No pudimos revisar tu bolsa. Vuelve a intentarlo antes de continuar.');
      } finally { win.clearTimeout(timer); }
    }
    async function readDelivery(cart, productURL) {
      var url = new win.URL(productURL || viewURL('cart'), win.location.origin);
      if (url.origin !== win.location.origin) throw problem('delivery_origin', 'No pudimos consultar la entrega de esta variante.');
      url.searchParams.set('section_id', 'reval-b04-delivery'); url.hash = '';
      var abort = new win.AbortController();
      var timer = win.setTimeout(function () { abort.abort(); }, 12000);
      try {
        var response = await win.fetch(url.toString(), { credentials: 'same-origin', cache: 'no-store', signal: abort.signal, headers: { Accept: 'text/html' } });
        if (!response.ok) throw problem('delivery_read', 'No pudimos consultar la entrega. Vuelve a intentarlo.');
        var html = new win.DOMParser().parseFromString(await response.text(), 'text/html');
        var node = html.querySelector('[data-b04-delivery-snapshot]');
        if (!node) throw problem('delivery_read', 'No pudimos verificar la entrega. Recarga tu bolsa antes de continuar.');
        var snapshot = JSON.parse(node.textContent);
        recordsFromSnapshot(cart, snapshot);
        return snapshot;
      } catch (error) {
        if (error.code) throw error;
        throw problem('delivery_read', 'No pudimos verificar la entrega. Vuelve a intentarlo.');
      } finally { win.clearTimeout(timer); }
    }
    function collectRows() {
      if (!nativeCart) return [];
      return Array.from(nativeCart.querySelectorAll('[data-b-cart-line]')).map(function (node) {
        var input = node.querySelector('[name="updates[]"]');
        return { node: node, input: input, key: node.dataset.lineKey, variantId: node.dataset.variantId,
          serverQuantity: node.dataset.serverQuantity, value: input.value };
      });
    }
    async function updateFromView() {
      if (!nativeCart) return false;
      var result = await controller.updateQuantities(collectRows());
      if (!result.changed) return false;
      // Re-render totals and routes after Shopify applies requested quantities.
      // Never submit edited updates[] and checkout using a previous-quantity ETA.
      status('Cantidades actualizadas. Revisa tu bolsa antes de continuar.');
      win.location.assign(viewURL('cart'));
      return true;
    }
    function status(message) {
      var node = doc.querySelector('[data-b-cart-status]') || doc.querySelector('[data-add-status]');
      if (node) { node.textContent = message || ''; node.hidden = !message; }
    }
    function syncRows(cart, plan) {
      if (!nativeCart) return;
      var resolved = reconcileRows(cart, collectRows(), controller.resolveKey);
      var list = nativeCart.querySelector('.cart-lines');
      var deliveries = new Map((plan || []).map(function (x) { return [x.key, x.delivery.text]; }));
      resolved.forEach(function (entry) {
        var row = entry.row;
        row.node.dataset.lineKey = entry.key;
        row.node.dataset.serverQuantity = String(entry.serverQuantity);
        row.input.value = String(entry.value);
        var remove = row.node.querySelector('[data-remove-key]');
        if (remove) remove.dataset.removeKey = entry.key;
        list.appendChild(row.node);
        row.node.querySelectorAll('[data-b-delivery-property]').forEach(function (node) { node.textContent = deliveries.get(entry.key) || ''; });
      });
    }
    function present(cart, plan) {
      lastCart = cart; lastDelivery = plan || [];
      syncRows(cart, plan);
      status(cart.items.length && pending ? 'Actualizamos la entrega de tu selección. Revisa el plazo de cada línea antes de continuar.' : '');
    }
    function promptNotice(error) {
      return new Promise(function (resolve) {
        var dialog = doc.createElement('dialog');
        dialog.className = 'b-cart-dialog';
        dialog.setAttribute('aria-label', error ? 'Revisa tu bolsa' : 'Entrega actualizada');
        dialog.style.cssText = 'width:min(90vw,36rem);max-height:85vh;overflow:auto;padding:24px;border:1px solid currentColor;background:#fff;color:#171717;line-height:1.5;';
        var heading = doc.createElement('h2');
        heading.textContent = error ? 'Revisa tu bolsa' : 'Actualizamos la entrega de tu selección';
        var text = doc.createElement('p'); text.textContent = error ? error.message : 'Comprueba el plazo de cada línea antes de continuar.';
        dialog.appendChild(heading); dialog.appendChild(text);
        if (!error && lastCart) {
          var lines = doc.createElement('ul');
          lastDelivery.forEach(function (entry) {
            var item = lastCart.items.find(function (x) { return x.key === entry.key; });
            var line = doc.createElement('li');
            line.textContent = (item ? (item.product_title || item.title || entry.variantId) + (item.variant_title ? ' · ' + item.variant_title : '') + ' × ' + item.quantity : entry.variantId) + ' — ' + entry.delivery.text;
            lines.appendChild(line);
          });
          dialog.appendChild(lines);
        }
        function close(result) { if (dialog.open) dialog.close(); dialog.remove(); resolve(result); }
        if (!error) {
          var proceed = doc.createElement('button'); proceed.type = 'button'; proceed.className = 'primary';
          proceed.textContent = 'He leído el plazo. Continuar'; proceed.addEventListener('click', function () { close(true); });
          dialog.appendChild(proceed);
        }
        var back = doc.createElement('button'); back.type = 'button'; back.className = 'text-link'; back.style.margin = '16px 0 0';
        back.textContent = 'Volver a la bolsa'; back.addEventListener('click', function () { close(false); }); dialog.appendChild(back);
        dialog.addEventListener('cancel', function (event) { event.preventDefault(); close(false); });
        doc.body.appendChild(dialog); dialog.showModal(); back.focus();
      });
    }
    var controller = createController({
      getCart: function () { return request('cart.js'); },
      getDelivery: readDelivery,
      changeItem: function (payload) { return request('cart/change.js', payload); },
      addItem: function (data) { return request('cart/add.js', data); },
      onChangeStarted: function () { state.setPending(true); }
    });
    var gate = createGate(controller, state, function () { return promptNotice(); }, present);
    function act(work) {
      if (actionFlight) return actionFlight;
      actionFlight = Promise.resolve().then(work).catch(function (error) { status(error.message); return promptNotice(error); });
      var current = actionFlight;
      current.then(function () { if (actionFlight === current) actionFlight = null; });
      return current;
    }
    function stop(event) { event.preventDefault(); event.stopImmediatePropagation(); }
    function nativeSubmit(form, submitter) {
      bypass = form;
      form.requestSubmit(submitter);
      bypass = null;
    }
    // One delegated submit listener; B does not instantiate Impulse CartForm.
    win.addEventListener('submit', function (event) {
      var form = event.target;
      if (bypass === form) { bypass = null; return; }
      if (form === nativeCart) {
        var submitter = event.submitter;
        var checkout = submitter && submitter.name === 'checkout';
        if (checkout && nativeCart.dataset.checkoutEnabled !== 'true') { stop(event); status('El pago no está disponible en esta vista.'); return; }
        stop(event);
        act(async function () {
          if (await updateFromView()) return;
          if (checkout) return gate(async function () {
            if (!await updateFromView()) nativeSubmit(form, submitter);
          });
          var result = await controller.sanitize();
          if (result.changed) state.setPending(true);
          present(result.cart, result.delivery);
        });
      } else if (form && form.matches && form.matches('[data-native-add]')) {
        if (form.dataset.variantPending === 'true') { stop(event); status('Completa la selección de medida y color antes de agregar a la bolsa.'); return; }
        stop(event);
        act(async function () {
          var button = form.querySelector('button[type="submit"]');
          if (button) button.disabled = true;
          status('Agregando a tu bolsa…');
          try {
            if (form === pageAddForm) restoreRenderedVariant();
            await controller.add(new win.FormData(form), form.dataset.deliveryUrl || win.location.href);
            win.location.assign(viewURL('cart'));
          } finally { if (button) button.disabled = false; }
        });
      }
    }, true);
    win.addEventListener('click', function (event) {
      var element = event.target && event.target.closest ? event.target : null;
      if (!element) return;
      var remove = element.closest('[data-remove-key]');
      if (remove) {
        stop(event);
        act(async function () {
          remove.disabled = true;
          try {
            await controller.coordinate(async function () {
              var cart = await request('cart.js');
              var key = controller.resolveKey(remove.dataset.removeKey);
              if (!cart.items.some(function (item) { return item.key === key; })) throw problem('line_changed', 'Tu bolsa cambió. Recárgala antes de quitar esta variante.');
              await request('cart/change.js', { id: key, quantity: 0 });
            });
            win.location.reload();
          } finally { remove.disabled = false; }
        });
        return;
      }
      var link = element.closest('a[href]');
      if (!link || link === bypassLink) return;
      var url = new win.URL(link.href, win.location.href);
      if (url.origin !== win.location.origin || !/\/checkouts?(?:\/|$)/.test(url.pathname)) return;
      stop(event);
      if (!doc.querySelector('[data-commercial-native]')) { status('El pago no está disponible en esta vista.'); return; }
      act(async function () {
        if (await updateFromView()) return;
        return gate(async function () {
          if (await updateFromView()) return;
          bypassLink = link; link.click(); bypassLink = null;
        });
      });
    }, true);

    var nav = doc.getElementById('main-nav'), menu = doc.querySelector('.menu-toggle');
    if (menu && nav) menu.addEventListener('click', function () {
      var open = menu.getAttribute('aria-expanded') !== 'true';
      menu.setAttribute('aria-expanded', String(open)); nav.classList.toggle('is-open', open);
    });
    doc.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && menu && nav) { menu.setAttribute('aria-expanded', 'false'); nav.classList.remove('is-open'); }
    });
    if (select) select.addEventListener('change', function () { win.location.assign(variantURL(select.dataset.productUrl, select.value, win.location.href)); });
    var gallery = doc.querySelector('[data-product-gallery]');
    if (gallery) {
      var productImage = doc.getElementById('primary-product-image');
      var galleryDialog = doc.getElementById('reval-gallery-dialog');
      var zoomTrigger = gallery.querySelector('[data-gallery-zoom]');
      var enlarged = galleryDialog && galleryDialog.querySelector('[data-gallery-enlarged]');
      var original = galleryDialog && galleryDialog.querySelector('[data-gallery-original]');
      var chosen = gallery.querySelector('[data-gallery-view][aria-pressed="true"]');
      var zoomSource = chosen ? chosen.dataset.gallerySrc : (productImage && (productImage.dataset.galleryOriginal || productImage.src));
      function updateZoom() {
        if (!productImage || !zoomSource) return;
        if (enlarged) { enlarged.src = zoomSource; enlarged.alt = productImage.alt; }
        if (original) original.href = zoomSource;
      }
      gallery.querySelectorAll('[data-gallery-view]').forEach(function (button) {
        button.addEventListener('click', function () {
          if (!productImage || !button.dataset.gallerySrc) return;
          // A view changes only media. The purchase selection and URL remain intact.
          productImage.removeAttribute('srcset');
          productImage.removeAttribute('sizes');
          productImage.src = button.dataset.gallerySrc;
          productImage.alt = button.dataset.galleryAlt || productImage.alt;
          zoomSource = button.dataset.gallerySrc;
          gallery.querySelectorAll('[data-gallery-view]').forEach(function (node) { node.setAttribute('aria-pressed', String(node === button)); });
          if (galleryDialog && galleryDialog.open) updateZoom();
        });
      });
      if (zoomTrigger && galleryDialog && productImage) {
        zoomTrigger.addEventListener('click', function () {
          if (typeof galleryDialog.showModal !== 'function') {
            win.open(zoomSource, '_blank', 'noopener');
            return;
          }
          updateZoom();
          if (!galleryDialog.open) galleryDialog.showModal();
        });
        var closeGallery = galleryDialog.querySelector('[data-gallery-close]');
        if (closeGallery) closeGallery.addEventListener('click', function () { galleryDialog.close(); });
        galleryDialog.addEventListener('close', function () { zoomTrigger.focus(); });
      }
    }
    function passiveCheck() {
      if (!nativeCart) return;
      controller.sanitize().then(function (result) {
        if (result.changed) state.setPending(true);
        present(result.cart, result.delivery);
      }).catch(function (error) { status(error.message); });
    }
    if (nativeCart) passiveCheck();
    win.addEventListener('pageshow', function (event) {
      restoreRenderedVariant();
      // Some history traversals restore form state after pageshow; repeat at the
      // next task without navigation, URL changes, or a synthetic change event.
      if (restoreVariantTimer !== null) win.clearTimeout(restoreVariantTimer);
      restoreVariantTimer = win.setTimeout(function () { restoreVariantTimer = null; restoreRenderedVariant(); }, 0);
      if (event.persisted) passiveCheck();
    });
  }
  return { variantId: VARIANT, isTarget: isTarget, correctedProperties: correctedProperties,
    resolveDelivery: resolveDelivery, recordsFromSnapshot: recordsFromSnapshot, planCart: planCart, quantitySignature: quantitySignature, addBalance: addBalance,
    cartSignature: cartSignature, createController: createController, createGate: createGate,
    prepareAddData: prepareAddData, reconcileRows: reconcileRows, variantURL: variantURL, mount: mount };
});
